import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function OrderSuccess() {
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const history = JSON.parse(sessionStorage.getItem("orderHistory")) || [];
    let latestOrder = history[history.length - 1];

    if (!latestOrder) {
      navigate("/shop");
      return;
    }

    if (!latestOrder.orderNumber) {
      latestOrder.orderNumber = "#" + Math.floor(10000 + Math.random() * 90000);
      history[history.length - 1] = latestOrder;
      sessionStorage.setItem("orderHistory", JSON.stringify(history));
    }

    setOrder(latestOrder);
  }, [navigate]);

  if (!order) return null;

  return (
    <div className="success-new-wrapper">
      <div className="container">
        {/* Top Animation Icon */}
        <div className="success-hero">
          <div className="checkmark-circle">
            <div className="checkmark">✓</div>
          </div>

          <h2 className="title">Your Order is Confirmed!</h2>
          <p className="subtitle">
            Thank you for shopping with us. Your order is being processed.
          </p>

          <div className="order-tag">Order No: {order.orderNumber}</div>
        </div>

        {/* Content Grid */}
        <div className="success-grid">
          {/* LEFT – Order Summary */}
          <div className="glass-card">
            <h3 className="card-heading">Order Summary</h3>

            {order.items.map((item) => (
              <div className="summary-line" key={item.id}>
                <span>
                  {item.name} × {item.quantity}
                </span>
                <strong>${(item.price * item.quantity).toFixed(2)}</strong>
              </div>
            ))}

            <div className="divider" />
            <div className="summary-total">
              <span>Total Paid</span>
              <strong>${order.total.toFixed(2)}</strong>
            </div>
          </div>

          {/* RIGHT – Shipping & Payment */}
          <div className="glass-card">
            <h3 className="card-heading">Delivery & Payment</h3>

            <div className="info-section">
              <h4>Shipping Details</h4>
              <p>
                <strong>{order.customer.name}</strong>
              </p>
              <p>{order.customer.address}</p>
              <p>
                {order.customer.city}, {order.customer.postal}
              </p>
              <p>📞 {order.customer.phone}</p>
              <p>📧 {order.customer.email}</p>
            </div>

            <div className="info-section mt-20">
              <h4>Payment Method</h4>
              <p>
                {order.method === "cod" ? "Cash on Delivery" : "Online Payment"}
              </p>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="actions">
          <Link to="/track-order" className="btn-primary">
            Track Order
          </Link>
          <Link to="/shop" className="btn-outline">
            Continue Shopping
          </Link>
        </div>
      </div>

      {/* CSS */}
      <style>{`
        .success-new-wrapper {
          padding: 70px 0;
          background: linear-gradient(135deg, #eef3ff 0%, #f5faff 100%);
        }

        /* Top section */
        .success-hero {
          text-align: center;
          margin-bottom: 40px;
        }

        .checkmark-circle {
          width: 110px;
          height: 110px;
          border-radius: 50%;
          background: #28c76f;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
          animation: pop .5s ease-out;
        }

        @keyframes pop {
          0% { transform: scale(0.3); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }

        .checkmark {
          color: #fff;
          font-size: 60px;
          font-weight: bold;
        }

        .title {
          font-size: 32px;
          font-weight: 700;
          color: #222;
        }

        .subtitle {
          color: #666;
          font-size: 16px;
          margin-top: 4px;
        }

        .order-tag {
          display: inline-block;
          margin-top: 12px;
          background: #e5f2ff;
          padding: 10px 20px;
          border-radius: 8px;
          font-weight: 700;
          font-size: 17px;
          color: #0b61d6;
        }

        /* Grid layout */
        .success-grid {
          display: grid;
          grid-template-columns: 1.3fr 1fr;
          gap: 25px;
          margin-top: 40px;
        }

        @media (max-width: 900px) {
          .success-grid {
            grid-template-columns: 1fr;
          }
        }

        /* Glass Cards */
        .glass-card {
          background: rgba(255, 255, 255, 0.85);
          backdrop-filter: blur(10px);
          padding: 25px;
          border-radius: 16px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.07);
        }

        .card-heading {
          font-size: 22px;
          font-weight: 700;
          margin-bottom: 18px;
        }

        /* Summary Lines */
        .summary-line {
          display: flex;
          justify-content: space-between;
          padding: 8px 0;
          border-bottom: 1px dashed #ccc;
        }

        .divider {
          border-bottom: 1px solid #ccc;
          margin: 12px 0;
        }

        .summary-total {
          display: flex;
          justify-content: space-between;
          font-size: 19px;
          font-weight: 700;
        }

        /* Info sections */
        .info-section h4 {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 10px;
        }

        .info-section p {
          margin: 4px 0;
          color: #444;
        }

        .mt-20 { margin-top: 20px; }

        /* Buttons */
        .actions {
          text-align: center;
          margin-top: 40px;
          display: flex;
          justify-content: center;
          gap: 14px;
        }

        .btn-primary {
          background: #0b61d6;
          color: #fff;
          padding: 14px 28px;
          border-radius: 10px;
          text-decoration: none;
          font-weight: 700;
          transition: .3s;
        }

        .btn-primary:hover {
          background: #084db5;
        }

        .btn-outline {
          border: 2px solid #0b61d6;
          padding: 14px 26px;
          border-radius: 10px;
          font-weight: 700;
          text-decoration: none;
          color: #0b61d6;
          transition: .3s;
        }

        .btn-outline:hover {
          background: #0b61d6;
          color: #fff;
        }
      `}</style>
    </div>
  );
}

export default OrderSuccess;
